<template lang="pug">
table.release_note
  thead(@click="showDetail()")
    th.type(v-bind:class="{'clickable': isMd || hasBr}")
      span(style="font-weight: bold; text-decoration: underline;") {{title}}
      span.icon(v-if='isMd || hasBr' v-bind:class="{'fa fa-caret-down': isCollapse, 'fa fa-caret-up': !isCollapse}")
  tbody(v-if='isMd')
    tr
      td.content(v-html="marked(content)" v-bind:class="{'collapse': isCollapse}")
  tbody(v-if='!isMd && !hasBr')
    tr
      td.content {{ computedContent }}
  tbody(v-if='!isMd && hasBr')
    tr(v-for='($index, s) in computedContent' track-by="$index")
      td.content(v-bind:class="{'collapse': isCollapse}") {{s}}
</template>

<script>
import marked from 'marked';
export default {
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    },
    class: {
      type: String
    },
    isMd: {
      type: Boolean
    },
    defaultCollapse: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isCollapse: this.defaultCollapse
    }
  },
  computed: {
    uniContent () {
      return this.content.replace(/\r\n|\n\r|\r/, '\n')
    },
    hasBr () {
      return this.uniContent.indexOf('\n') !== -1
    },
    computedContent () {
      if (this.isMd || !this.hasBr) {
        return this.uniContent
      } else {
        return this.uniContent.split('\n')
      }
    }
  },
  methods: {
    marked,
    showDetail () {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style scoped lang="scss">
.type {
  color: #000;
  display: flex;
  align-items: center;
}
.icon {
  margin-left: 8px;
  transition: transform 0.3s ease;
  cursor: pointer; /* Add cursor pointer */
}
.icon.collapsed {
  transform: rotate(180deg);
}
.icon:hover {
  color: #007BFF; /* Change color on hover */
}
.content {
  padding-left: 0;
}
tr {
  display: table; // for firefox
}
.release_note {
  text-align: left;
  width: 100%;
  margin-bottom: 6px;
}
.collapse {
  display: none;
}
.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// LinedTable.vue?7b8b3c64